import React, { useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { EyeOffIcon, ClockIcon, StarIcon, XIcon } from 'lucide-react';
// Declare fbq on window for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function SalesPage() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  // Initialize Meta Pixel and track PageView
  useEffect(() => {
    // Load Meta Pixel script
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safe insertion: use head if no script tags exist
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize pixel
    window.fbq('init', '2117425409094757');
    // Track PageView
    window.fbq('track', 'PageView');
  }, []);
  const handleAddToCart = () => {
    // Track AddToCart event
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Repostería Keto para Familias',
        content_ids: ['46934885859479'],
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    // Redirect to Shopify cart
    window.location.href = 'https://www.enfoquebasico.com/cart/46934885859479:1';
  };
  const scrollToCTA = () => {
    const offerSection = document.getElementById('offer');
    offerSection?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 30
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      margin: '-100px'
    },
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  };
  return <main className="w-full min-h-screen bg-gradient-to-b from-[#FFFAF0] to-[#FFF8DC]" data-id="element-2">
      {/* Hero Section */}
      <section className="relative w-full min-h-screen flex items-center justify-center px-4 py-16 md:py-24 overflow-hidden" data-id="element-3">
        <div className="absolute inset-0 opacity-5" data-id="element-4">
          <div className="absolute top-20 left-10 w-64 h-64 bg-[#D2691E] rounded-full blur-3xl" data-id="element-5"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#9CAF88] rounded-full blur-3xl" data-id="element-6"></div>
        </div>

        <div className="relative max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-7">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center md:text-left" data-id="element-8">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#8B4513] leading-tight mb-6" data-id="element-9">
              Mamá, ¿puedo repetir?
            </h1>
            <p className="text-xl md:text-2xl text-[#D2691E] font-medium mb-8 leading-relaxed" data-id="element-10">
              La frase que antes te daba miedo y que hoy será tu mayor orgullo.
            </p>
            <button onClick={scrollToCTA} className="inline-block bg-[#9CAF88] hover:bg-[#7A9370] text-white font-semibold text-lg px-10 py-4 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300" aria-label="Obtener el recetario con 78% de descuento" data-id="element-11">
              Obtener el Recetario con 78% de Descuento
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="flex justify-center" data-id="element-12">
            <img src="https://cdn.magicpatterns.com/uploads/pxeZeaPjd5uqaZcNQ2BjPc/logo.png" alt="Repostería Keto para Familias - Producto" className="w-full max-w-md rounded-2xl shadow-2xl" data-id="element-13" />
          </motion.div>
        </div>
      </section>

      {/* Problem Section */}
      <motion.section {...fadeInUp} className="w-full px-4 py-20 md:py-32 bg-white" data-id="element-14">
        <div className="max-w-4xl mx-auto text-center" data-id="element-15">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#8B4513] mb-8" data-id="element-16">
            El Dilema Diario
          </h2>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed italic" data-id="element-17">
            Míralos a los ojos. Cada vez que les prohíbes ese dulce procesado,
            te sientes como el "villano" de la historia. Pero cada vez que
            cedes, sientes la culpa de saber que ese azúcar está inflamando su
            cuerpo y robándoles la concentración.
          </p>
        </div>
      </motion.section>

      {/* Solution Section */}
      <motion.section {...fadeInUp} className="w-full px-4 py-20 md:py-32 bg-gradient-to-br from-[#FFF8DC] to-[#FFFAF0]" data-id="element-18">
        <div className="max-w-4xl mx-auto" data-id="element-19">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#8B4513] mb-8 text-center" data-id="element-20">
            ¿Y si dejaras de pelear?
          </h2>
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12" data-id="element-21">
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6" data-id="element-22">
              Te presento{' '}
              <span className="font-bold text-[#D2691E]" data-id="element-23">
                Repostería Keto para Familias
              </span>
              . No es un libro de cocina común; es un{' '}
              <span className="font-semibold" data-id="element-24">
                sistema de "Hackeo Nutricional"
              </span>
              .
            </p>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-25">
              Hemos tomado las texturas que ellos aman (esponjosas, cremosas,
              crocantes) y hemos reemplazado el veneno por combustible real.
            </p>
          </div>
        </div>
      </motion.section>

      {/* Why It Works Section */}
      <motion.section {...fadeInUp} className="w-full px-4 py-20 md:py-32 bg-white" data-id="element-26">
        <div className="max-w-6xl mx-auto" data-id="element-27">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#8B4513] mb-16 text-center" data-id="element-28">
            Por Qué Funciona
          </h2>

          <div className="grid md:grid-cols-3 gap-8 md:gap-12" data-id="element-29">
            <motion.div {...fadeInUp} transition={{
            delay: 0.1
          }} className="text-center" data-id="element-30">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-[#9CAF88] rounded-full mb-6" data-id="element-31">
                <EyeOffIcon className="w-10 h-10 text-white" aria-hidden="true" data-id="element-32" />
              </div>
              <h3 className="text-2xl font-bold text-[#8B4513] mb-4" data-id="element-33">
                Ingredientes Invisibles
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-34">
                Usamos vegetales y grasas puras que desaparecen por completo al
                hornearse.
              </p>
            </motion.div>

            <motion.div {...fadeInUp} transition={{
            delay: 0.2
          }} className="text-center" data-id="element-35">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-[#D2691E] rounded-full mb-6" data-id="element-36">
                <ClockIcon className="w-10 h-10 text-white" aria-hidden="true" data-id="element-37" />
              </div>
              <h3 className="text-2xl font-bold text-[#8B4513] mb-4" data-id="element-38">
                Cero Complicaciones
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-39">
                Recetas de máximo 15 minutos.
              </p>
            </motion.div>

            <motion.div {...fadeInUp} transition={{
            delay: 0.3
          }} className="text-center" data-id="element-40">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-[#8B4513] rounded-full mb-6" data-id="element-41">
                <StarIcon className="w-10 h-10 text-white" aria-hidden="true" data-id="element-42" />
              </div>
              <h3 className="text-2xl font-bold text-[#8B4513] mb-4" data-id="element-43">
                Sabor Real
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-44">
                Si no sabe a postre premium, no está en este libro.
              </p>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* Offer Section */}
      <motion.section {...fadeInUp} id="offer" className="w-full px-4 py-20 md:py-32 bg-gradient-to-br from-[#9CAF88] to-[#7A9370]" data-id="element-45">
        <div className="max-w-4xl mx-auto" data-id="element-46">
          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-16 text-center" data-id="element-47">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#8B4513] mb-8" data-id="element-48">
              La Oferta Insuperable
            </h2>

            <div className="mb-10" data-id="element-49">
              <div className="inline-block" data-id="element-50">
                <p className="text-gray-600 text-lg mb-2" data-id="element-51">Precio original</p>
                <p className="text-3xl md:text-4xl font-bold text-gray-400 line-through mb-3" data-id="element-52">
                  $29
                </p>
                <div className="inline-flex items-center gap-3 mb-4" data-id="element-53">
                  <span className="bg-[#9CAF88] text-white text-sm font-bold px-4 py-1 rounded-full" data-id="element-54">
                    78% DE DESCUENTO
                  </span>
                </div>
                <p className="text-gray-600 text-lg mb-2" data-id="element-55">Hoy por solo</p>
                <p className="text-6xl md:text-7xl font-bold text-[#D2691E] mb-2" data-id="element-56">
                  $6.39
                </p>
                <p className="text-gray-600 text-xl" data-id="element-57">USD</p>
              </div>
            </div>

            <div className="bg-[#FFFAF0] rounded-2xl p-8 mb-10 text-left" data-id="element-58">
              <h3 className="text-2xl font-bold text-[#8B4513] mb-6 text-center" data-id="element-59">
                Incluye:
              </h3>
              <ul className="space-y-4 text-lg text-gray-700" data-id="element-60">
                <li className="flex items-start" data-id="element-61">
                  <span className="inline-block w-2 h-2 bg-[#9CAF88] rounded-full mt-2 mr-4 flex-shrink-0" data-id="element-62"></span>
                  <span data-id="element-63">El recetario completo con paso a paso detallado</span>
                </li>
                <li className="flex items-start" data-id="element-64">
                  <span className="inline-block w-2 h-2 bg-[#9CAF88] rounded-full mt-2 mr-4 flex-shrink-0" data-id="element-65"></span>
                  <span data-id="element-66">
                    Los 10 "Favoritos Ocultos" que engañan hasta al paladar más
                    exigente
                  </span>
                </li>
                <li className="flex items-start" data-id="element-67">
                  <span className="inline-block w-2 h-2 bg-[#9CAF88] rounded-full mt-2 mr-4 flex-shrink-0" data-id="element-68"></span>
                  <span data-id="element-69">La guía de compras para el supermercado</span>
                </li>
              </ul>
            </div>

            <button onClick={handleAddToCart} className="bg-[#8B4513] hover:bg-[#6d3410] text-white font-bold text-xl px-12 py-5 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300" aria-label="Comprar ahora por $6.39" data-id="element-70">
              Sí, Quiero Terminar la Guerra del Dulce
            </button>

            <p className="text-gray-600 text-sm mt-8" data-id="element-71">
              Acceso inmediato después de la compra
            </p>
          </div>
        </div>
      </motion.section>

      {/* Footer */}
      <footer className="w-full px-4 py-8 bg-[#8B4513] text-center" data-id="element-72">
        <div className="max-w-4xl mx-auto" data-id="element-73">
          <div className="flex flex-wrap justify-center items-center gap-6 mb-4" data-id="element-74">
            <button onClick={() => setShowPrivacy(true)} className="text-[#FFF8DC] hover:text-white text-sm underline transition-colors" data-id="element-75">
              Política de Privacidad
            </button>
            <span className="text-[#FFF8DC] text-sm" data-id="element-76">•</span>
            <button onClick={() => setShowTerms(true)} className="text-[#FFF8DC] hover:text-white text-sm underline transition-colors" data-id="element-77">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-[#FFF8DC] text-sm" data-id="element-78">
            © 2026 Repostería Keto para Familias. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <AnimatePresence data-id="element-79">
        {showPrivacy && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowPrivacy(false)} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50" data-id="element-80" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="fixed inset-4 md:inset-auto md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-3xl md:max-h-[80vh] bg-white rounded-2xl shadow-2xl z-50 overflow-hidden" data-id="element-81">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between" data-id="element-82">
                <h2 className="text-2xl font-bold text-[#8B4513]" data-id="element-83">
                  Política de Privacidad
                </h2>
                <button onClick={() => setShowPrivacy(false)} className="p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Cerrar" data-id="element-84">
                  <XIcon className="w-6 h-6 text-gray-600" data-id="element-85" />
                </button>
              </div>
              <div className="overflow-y-auto max-h-[calc(80vh-80px)] px-6 py-6" data-id="element-86">
                <div className="prose prose-sm max-w-none" data-id="element-87">
                  <p className="text-gray-600 mb-4" data-id="element-88">
                    <strong data-id="element-89">Última actualización:</strong> Febrero 2026
                  </p>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-90">
                    1. Información que Recopilamos
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-91">
                    Recopilamos información personal que usted nos proporciona
                    directamente al realizar una compra, incluyendo nombre,
                    dirección de correo electrónico, y información de pago.
                  </p>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-92">
                    2. Uso de la Información
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-93">
                    Utilizamos su información para:
                  </p>
                  <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-94">
                    <li data-id="element-95">Procesar y entregar su pedido</li>
                    <li data-id="element-96">Enviarle el recetario digital</li>
                    <li data-id="element-97">Comunicarnos con usted sobre su compra</li>
                    <li data-id="element-98">Mejorar nuestros productos y servicios</li>
                  </ul>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-99">
                    3. Protección de Datos
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-100">
                    Implementamos medidas de seguridad para proteger su
                    información personal. Utilizamos encriptación SSL para todas
                    las transacciones y no almacenamos información de tarjetas
                    de crédito en nuestros servidores.
                  </p>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-101">
                    4. Compartir Información
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-102">
                    No vendemos, intercambiamos ni transferimos su información
                    personal a terceros, excepto a proveedores de servicios de
                    confianza que nos ayudan a operar nuestro sitio web y
                    procesar pagos.
                  </p>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-103">
                    5. Sus Derechos
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-104">
                    Usted tiene derecho a acceder, corregir o eliminar su
                    información personal en cualquier momento. Para ejercer
                    estos derechos, contáctenos a través de nuestro correo
                    electrónico de soporte.
                  </p>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-105">
                    6. Cookies
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-106">
                    Utilizamos cookies para mejorar su experiencia de navegación
                    y analizar el tráfico del sitio. Puede configurar su
                    navegador para rechazar cookies, aunque esto puede afectar
                    algunas funcionalidades del sitio.
                  </p>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-107">
                    7. Cambios a esta Política
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-108">
                    Nos reservamos el derecho de actualizar esta política de
                    privacidad en cualquier momento. Los cambios entrarán en
                    vigor inmediatamente después de su publicación en esta
                    página.
                  </p>
                </div>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>

      {/* Terms and Conditions Modal */}
      <AnimatePresence data-id="element-109">
        {showTerms && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowTerms(false)} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50" data-id="element-110" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="fixed inset-4 md:inset-auto md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-3xl md:max-h-[80vh] bg-white rounded-2xl shadow-2xl z-50 overflow-hidden" data-id="element-111">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between" data-id="element-112">
                <h2 className="text-2xl font-bold text-[#8B4513]" data-id="element-113">
                  Términos y Condiciones
                </h2>
                <button onClick={() => setShowTerms(false)} className="p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Cerrar" data-id="element-114">
                  <XIcon className="w-6 h-6 text-gray-600" data-id="element-115" />
                </button>
              </div>
              <div className="overflow-y-auto max-h-[calc(80vh-80px)] px-6 py-6" data-id="element-116">
                <div className="prose prose-sm max-w-none" data-id="element-117">
                  <p className="text-gray-600 mb-4" data-id="element-118">
                    <strong data-id="element-119">Última actualización:</strong> Febrero 2026
                  </p>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-120">
                    1. Aceptación de los Términos
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-121">
                    Al acceder y utilizar este sitio web y realizar una compra,
                    usted acepta estar sujeto a estos términos y condiciones de
                    uso. Si no está de acuerdo con alguna parte de estos
                    términos, no debe utilizar nuestro sitio.
                  </p>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-122">
                    2. Producto Digital
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-123">
                    "Repostería Keto para Familias" es un producto digital
                    (recetario en formato PDF) que se entrega por correo
                    electrónico inmediatamente después de completar la compra.
                  </p>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-124">
                    3. Licencia de Uso
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-125">
                    Al comprar el recetario, usted obtiene una licencia de uso
                    personal no transferible. Está prohibido:
                  </p>
                  <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-126">
                    <li data-id="element-127">Revender, redistribuir o compartir el contenido</li>
                    <li data-id="element-128">Modificar o crear obras derivadas sin autorización</li>
                    <li data-id="element-129">Utilizar el contenido con fines comerciales</li>
                    <li data-id="element-130">Eliminar marcas de agua o información de copyright</li>
                  </ul>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-131">
                    4. Política de Reembolso
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-132">
                    Debido a la naturaleza digital del producto, no ofrecemos
                    reembolsos una vez que el recetario ha sido entregado y
                    descargado. Sin embargo, si experimenta problemas técnicos
                    con la descarga o acceso al contenido, contáctenos dentro de
                    las 48 horas posteriores a la compra.
                  </p>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-133">
                    5. Descargo de Responsabilidad
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-134">
                    Las recetas y consejos nutricionales proporcionados son solo
                    para fines informativos. No sustituyen el consejo médico
                    profesional. Consulte con un profesional de la salud antes
                    de realizar cambios significativos en su dieta o la de su
                    familia.
                  </p>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-135">
                    6. Propiedad Intelectual
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-136">
                    Todo el contenido del recetario, incluyendo textos,
                    imágenes, recetas y diseño, está protegido por derechos de
                    autor y es propiedad exclusiva de Repostería Keto para
                    Familias.
                  </p>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-137">
                    7. Limitación de Responsabilidad
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-138">
                    No nos hacemos responsables de alergias alimentarias,
                    reacciones adversas o resultados de salud derivados del uso
                    de las recetas. Es responsabilidad del usuario verificar
                    ingredientes y adaptar las recetas según necesidades
                    dietéticas específicas.
                  </p>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-139">
                    8. Modificaciones
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-140">
                    Nos reservamos el derecho de modificar estos términos en
                    cualquier momento. Los cambios entrarán en vigor
                    inmediatamente después de su publicación en esta página.
                  </p>

                  <h3 className="text-lg font-bold text-[#8B4513] mt-6 mb-3" data-id="element-141">
                    9. Contacto
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-142">
                    Para cualquier pregunta sobre estos términos, puede
                    contactarnos a través del correo electrónico proporcionado
                    en su confirmación de compra.
                  </p>
                </div>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </main>;
}